
/*
----- Update Url ----- 
- This interacts with the history api ( https://developer.mozilla.org/en-US/docs/Web/API/History_API ) to manipulate the url. 
*/


function initialise(context) {
    // Get current url.
    let current = location.href;
    // Replacement Url.
    const replacement = getUrl(context);
    // If the url has not been previous updated via ajax then replace it with the url given on pageload.
    if (current != replacement) {
        // Current url will be updated with the url from vMerchant.
        replace(context);
        AXISDebug.output(1, "Update Url: Replacing the url due to page load.");
    }
}

// Extract url from context.
function getUrl(context) {
    let url = context.attr(expressSelectors()['update-url']);
    // Add Fallback for Old product list mechanism.
    if (!url) {
        url = context.attr('data-url');
        if (url == undefined || url.length == 0) {
            AXISDebug.output(3,"Update url: Failed to get new url from DOM element.");
            return false;
        }
    }
    return url;
}

// Set url will change the URL, and keep the old one in the browser history (ie. pressing the back button will take you back)
function set(context, isInContext) {
    // Get Url.
    let url = (isInContext ? context : getUrl(context));
    if (!url) {
        return false;
    }
    // Get previous url.
    const previousUrl = location.href;
    try {
        const push = history.pushState({
            'pushed': true,
            'previous-url': previousUrl
        }, "", url);
        return push;
    } catch(error) {
        AXISDebug.output(3,error);
        return false;
    }
}

// Just incase the user hits the back button multiple times delay the reload function.
let popstateTimeout;
// Add event for if the user navigates the session history.
$(window).on('popstate', function (event) {
    // Get the original state.
    const state = event.originalEvent.state;
    
    if (state) {
        // Clear timeout.
        clearTimeout(popstateTimeout);
        // Was this entry pushed? this is important as we typical replace the URl on page load, pushing only gets set in situations such a applying a filter or stockline selection.
        const pushed = (state.hasOwnProperty('pushed') ? state['pushed'] : false);
        // Run check against original.
        if (state && pushed) {
            // If the user hits back and we have updated the location via push then reload the window.
            popstateTimeout = setTimeout(function () {
                reloadPage();
            }, 100);
        }
    } else {
        reloadPage();
    }
});

//  Replace Url will change the URL in the browser (ie. pressing the back button won't take you back)
function replace(context) {
    // Get Url.
    let url = getUrl(context);
    if (!url) {
        return false;
    }
    // Get previous url.
    const previous = location.href;
    // Skip if in the localhost environment to avoid CORS errors.
    if (location.hostname == "localhost") {
        AXISDebug.output(2,"Updated Url: Skipping due to being in the localhost environment.")
        return true;
    } 
    
    let update = history.replaceState({
        'replaced': true,
        'previous-url': previous
    }, "", url);

    if (!update) {
        AXISDebug.output(3,"Update url: Failed to replace the url, the url that was provided was: " + url);
        return false;
    } else {
        AXISDebug.output(1,"Update url: The Url has successfully been updated.");
        return true;
    }
}

var updateUrl = $.updateUrl = {
    initialise: (context) => {
        return initialise(context);
    },
    set: (context, isInContext) => {
        return set(context, isInContext);
    },
    replace: (context) => {
        return replace(context);
    }
}
 
export { updateUrl };
